//  About.js
//
//  Updated 1/25.
//
//  Abstract: About AllergI portal page.

//  React
import React from 'react';

//  Material-ui styles
import { 
    makeStyles, 
    Link, 
    Grid, 
    Typography 
} from '@material-ui/core';

import CardTemplate from '../__common__/CardTemplate/CardTemplate.js';

//	Define CSS styles
const useStyles = makeStyles((theme) => ({
    text: {
        textAlign: 'left',
    },
}));

export default function About(props) {

    //	CSS classes
    const classes = useStyles();

    return (
        <>
        <CardTemplate>
            <Grid container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}>
                <Grid item >
                    {/* <Typography variant="h6" className={classes.text}>
                        About
                    </Typography> */}
                </Grid>
                <Grid item className={classes.gridItem}>
                    <Typography variant="p" className={classes.text}>
                        AllergI is a patient-first, at-home allergen patch testing kit. This site is a patient portal between physician and patient.
                    </Typography>
                </Grid>
                <Grid item className={classes.gridItem}>
                    <Typography variant="p" className={classes.text}> 
                    From this portal, you may configure patient test sessions, configure If you have been issued credentials from your organization, login - otherwise register an account.
                    </Typography>
                </Grid>
                <Grid item className={classes.gridItem}>
                    <Typography variant="p" className={classes.text}> 
                    Please reach out to your organization's IT administrator or the contact AllergI Portal <Link href="/support" className={classes.link} color='textSecondary' variant="body2">{"support"}
                    </Link> if you need assistance.
                    </Typography>
                </Grid>
                <Grid item className={classes.gridItem} >
                    <Link href="/login" color='secondary' variant="body2">
                        {"Return to Login"}
                    </Link>
                </Grid>
            </Grid>
        </CardTemplate>
        </>
    );
}